<template>
  <v-container class="privacy-policy py-8">
    <v-card class="mx-auto" max-width="900" outlined>
      <v-card-title class="privacy-policy__title justify-center text-center">
        BSP+ Gizlilik Sözleşmesi
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-6 pa-md-10">
        <v-progress-linear
          v-if="loading"
          color="defaultColor"
          indeterminate
        />

        <v-alert v-else-if="error" type="error" text>
          Gizlilik sözleşmesi yüklenirken bir hata oluştu.
        </v-alert>

        <v-alert v-else-if="!agreementTexts.length" type="info" text>
          {{ $t("description.noContent") }}
        </v-alert>

        <article
          v-for="(agreement, index) in agreementTexts"
          v-else
          :key="`${agreement.Title}-${index}`"
          class="privacy-policy__section"
        >
          <h2 class="privacy-policy__heading">{{ agreement.Title }}</h2>
          <p class="privacy-policy__text">{{ agreement.Text }}</p>
        </article>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import AccountService from '@/services/AccountService'

export default {
  name: 'PrivacyPolicy',

  data() {
    return {
      agreementTexts: [],
      error: false,
      loading: true,
    }
  },

  mounted() {
    this.getAgreementTexts()
  },

  methods: {
    getAgreementTexts() {
      AccountService.getKvkkText()
        .then((response) => {
          const responseData = response.data
          this.agreementTexts = Array.isArray(responseData)
            ? responseData
            : responseData.Result || []
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.privacy-policy {
  min-height: 100%;
}

.privacy-policy__title {
  color: var(--v-defaultColor-base);
  font-size: 1.5rem;
  font-weight: 700;
}

.privacy-policy__section + .privacy-policy__section {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin-top: 1.5rem;
  padding-top: 1.5rem;
}

.privacy-policy__heading {
  color: var(--v-defaultColor-base);
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.privacy-policy__text {
  color: rgba(0, 0, 0, 0.75);
  line-height: 1.7;
  margin-bottom: 0;
  white-space: pre-line;
}
</style>
